// src/App.js
import React, { Suspense } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './routes';
import LoadingScreen from './components/common/LoadingScreen';
import './i18n';
import './assets/styles/global.css';

const App = () => {
  // Effet pour gérer les préférences de thème système
  React.useEffect(() => {
    // Vérifier si le système préfère le mode sombre
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    // Fonction pour mettre à jour le thème en fonction des préférences système
    const handleSystemThemeChange = (e) => {
      const prefersDarkMode = e.matches;
      const savedTheme = localStorage.getItem('propenta-theme');
      
      // Ne mettre à jour automatiquement que si l'utilisateur n'a pas déjà choisi un thème
      if (!savedTheme) {
        localStorage.setItem('propenta-theme', prefersDarkMode ? 'dark' : 'light');
      }
    };
    
    // Ajouter un écouteur d'événements pour les changements de thème système
    darkModeMediaQuery.addEventListener('change', handleSystemThemeChange);
    
    // Nettoyer l'écouteur d'événements
    return () => {
      darkModeMediaQuery.removeEventListener('change', handleSystemThemeChange);
    };
  }, []);
  
  return (
    <ThemeProvider>
      <Suspense fallback={<LoadingScreen />}>
        <AppRoutes />
      </Suspense>
    </ThemeProvider>
  );
};

export default App;